<template>
  <div class="page-content g9">
    <Accord title="Demand">

      <Accord title="Enrollment projection">
        <LineChart chart-name="demandEnrollment" :settings="enrollmentSettings"></LineChart>
      </Accord>

      <Accord title="Dispensing schedules">
        <LineChart chart-name="demandSchedules" :settings="schedulesSettings" :is-gantt="true"></LineChart>
        <button class="right" v-on:click="onDownloadDemandScheduleClick">Download dispensing schedule in excel</button>
      </Accord>

      <Accord title="Consumption">
        <LineChart chart-name="demandConsumption" :settings="consumptionSettings"></LineChart>
        <button class="right" v-on:click="onDownloadConsumptionsClick">Download to excel</button>
      </Accord>

    </Accord>
  </div>
</template>

<script>
import Accord from "../../Accord.vue"
import LineChart from "../Charts/LineChart.vue"

export default {
  components: {
    Accord,
    LineChart
  },
  methods: {
    enrollmentSettings(data) {
      let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
      chart.chart = {
        zoomType: "x"
      };
      chart.series = data.series;
      chart.xAxis.type = "datetime";
      chart.yAxis.title.text = "Subjects";
      chart.xAxis.title.text = "Date";

      return chart;
    },
    onDownloadDemandScheduleClick() {
      window.open("/api/download/DispensingSchedule?id=" + this.$route.params.id);
    },
    onDownloadConsumptionsClick() {
      window.open("/api/download/Consumptions?id=" + this.$route.params.id);
    },
    schedulesSettings(data) {
      let chart = {
        type: "gantt",
        legend: {
          align: "left",
          verticalAlign: "top",
          borderWidth: 0
        },
        title: {
          text: null
        },
        xAxis: [{
          type: "linear",
          cropThreshold: Number.MAX_VALUE,
          min: 0,
          allowDecimals: false,
          visible: true,
          useHTML: true,
          labels: {
            padding: 10,
            format: "{value}<br/>days",
          }
        }, {
          visible: false,
        }],
        yAxis: {
          uniqueNames: true,
          cropThreshold: Number.MAX_VALUE,
          title: {
            margin: 20,
            useHTML: true,
            text: "<b>TreatmentGroup</b>",
            rotation: 0,
            reserveSpace: false
          }
        },
        navigator: {
          enabled: true,
          liveRedraw: true,
          series: {
            type: "gantt",
            pointPlacement: 0.5,
            pointPadding: 0.25
          },
          yAxis: {
            reversed: true,
            categories: []
          },
          xAxis: {
            type: "linear",
            allowDecimals: false,
            labels: {
              format: "{value}",
            }
          }
        },
        credits: {
          enabled: false
        },
        scrollbar: {
          enabled: true
        },
        rangeSelector: {
          enabled: false
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.visitName}",
              style: {
                cursor: "default",
                pointerEvents: "none"
              }
            }
          }
        },
        tooltip: {
          //note, html options are limited: https://api.highcharts.com/highcharts/tooltip.formatter
          formatter: function (tooltip) {
            let html = `<b>${this.point.name}</b><br>
                            Visit name: <b>${this.point.visitName}</b><br>
                            Visit day: <b>${this.point.visitDay}</b><br>
                            Window before: <b>${this.point.before}</b><br>
                            Window after: <b>${this.point.after}</b><br>`;

            let thisRef = this;

            this.point.dispensingUnits.forEach((txt) => {

              //this is a 'dirty' backward compatible hack. Old array had dispensinunit as an object, new does not.

              let inValidDun = txt.dispensingUnit === undefined || txt.dispensingUnit === null

              if (inValidDun) {

                html += "<br/>" + txt.name + "<br/>";
                html += "<span style='white-space:pre'>   " + "Dispensing: " + txt.unitQuantity + "<br/>" + "</span>";
                html += "<span style='white-space:pre'>   " + "Extra: " + txt.extra + "<br/>" + "</span>";
                html += "<span style='white-space:pre'>   " + "Total per subject: " + txt.totalPerSubject + "<br/>" + "</span>";

              } else {
                html += txt.dispensingUnit.name + " Extra: <b>" + txt.extra + "</b>"
              }

            });

            return html;
          },
          split: false,
          style: {color: "black"}

        }
      };

      chart.series = data.series;

      return chart;
    },
    consumptionSettings(data) {
      let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);

      chart.chart = {
        zoomType: "x"
      };
      chart.tooltip = {
        shared: true,
        useHTML: true,
        headerFormat: '<small>{point.key}</small><table><tr><td style="padding: 2px;">DUN</td><td style="padding: 2px;">Total accumulated</td><td style="padding: 2px;">Consumption</td></tr>',
        pointFormat: '<tr><td style="color: {series.color};padding: 2px;">{series.name} </td>' +
            '<td style="text-align: right;padding: 2px;"><b>{point.total:,.f}&nbsp;</b></td>' +
            '<td style="text-align: right;padding: 2px;"><b>{point.quantity:,.f}</b></td></tr>',
        footerFormat: '</table>',
        valueDecimals: 2
      };

      for (let i = 0; i < data.series.length; i++) {
        data.series[i].data = data.series[i].data.map(function (row) {
          return {
            x: row.x,
            y: row.y,
            quantity: row.quantity,
            total: row.total
          }
        });
      }

      chart.series = data.series;
      chart.xAxis.type = "datetime";
      chart.yAxis.title.text = "DUN";
      chart.xAxis.title.text = "Date";

      return chart;
    }
  }
}
</script>
